import React from 'react';

const HorizontalDivider = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '1px',
        backgroundColor: '#C6C6C6',
        borderRadius: '2px',
      }}
    />
  );
};

export default HorizontalDivider;
